<template>
  <v-navigation-drawer v-model="drawer" app fixed clipped :permanent="drawer" :width="width">

    <v-list class="py-0">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold text-uppercase">Categorias</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item-group v-model="store.selectedItem" color="primary">
        <v-list-item value="Vestido">
          <v-list-item-content>
            <v-list-item-title>Vestido</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item value="Calças">
          <v-list-item-content>
            <v-list-item-title>Calças</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        
        <v-list-item value="Blusas">
          <v-list-item-content>
            <v-list-item-title>Blusas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        
        <v-divider></v-divider>

        <v-list-item :value="store.title">
          <v-list-item-content>
            <v-list-item-title>{{store.title}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

  </v-navigation-drawer>
</template>

<script setup>
import { ref } from 'vue';
import { usePDVStore } from '@/app/store/pinia/pdv';

const props = defineProps({
  width: {
    type: [Number, String],
    default: 250
  }
});

const store = usePDVStore();

const drawer = ref(true);

</script>

<style scoped>
</style>